t = require('views/internal/teacup-with-helpers')('header_boards_menu_button')

module.exports = ->
  t.a '.header-btn.header-boards.js-boards-menu', { href: '#' }, ->
    t.span '.header-btn-icon.icon-lg.icon-board.light'
    t.span '.header-btn-text', ->
      t.format 'boards'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_boards_menu_button.coffee